import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import apiClient from '../utils/axiosConfig';
import Loader from './loader';

const AdminRoute = ({ children }) => {
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    let mounted = true;

    const checkAdmin = async () => {
      // First try localStorage
      try {
        const stored = localStorage.getItem('user');
        console.log('AdminRoute: stored user:', stored);
        if (stored) {
          const user = JSON.parse(stored);
          console.log('AdminRoute: parsed user:', user);
          if (user && user.role === 'admin') {
            if (mounted) setIsAdmin(true);
            return;
          }

          // If we have a stored user and it's not admin, deny immediately
          if (user && user.role) {
            console.log('AdminRoute: user is not admin, denying access');
            if (mounted) setIsAdmin(false);
            return;
          }
        }
      } catch (e) {
        console.error('AdminRoute: error reading stored user', e);
      }

      // Fallback: ask backend for user profile
      try {
        const res = await apiClient.get('/auth/me');
        const user = res.data?.user || res.data;
        if (user && user.role === 'admin') {
          if (mounted) setIsAdmin(true);
        } else {
          if (mounted) setIsAdmin(false);
        }
      } catch (error) {
        console.error('Admin check failed:', error);
        if (mounted) setIsAdmin(false);
      }
    };

    checkAdmin();

    return () => { mounted = false; };
  }, []);

  if (isAdmin === null) {
    return <Loader />;
  }

  if (!isAdmin) {
    return <Navigate to="/not-authorized" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminRoute;
